import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { ArrowForward } from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";

import withFullScreen from "./hocs/withFullScreen";
import CustomButton from "./CustomButton";
import {
  CONTENT_FRAME_STYLE,
  CONTENT_GRID_PROPS,
  CONTENT_INNER_STYLE,
  FEATURE_SECTION_RADIUS,
  FEATURE_SECTION_EDGE_INSET,
} from "../layout";

const styles = () => ({});

export const HOME_HERO_IMAGES = {
  desktop1024:
    "https://res.cloudinary.com/energea/image/upload/c_fill,g_auto,h_576,q_auto:good,w_1024/f_webp/v1/energea/br-images/itaguai1.WebP",
  desktop1280:
    "https://res.cloudinary.com/energea/image/upload/c_fill,g_auto,h_720,q_auto:good,w_1280/f_webp/v1/energea/br-images/itaguai1.WebP",
  desktop1600:
    "https://res.cloudinary.com/energea/image/upload/c_fill,g_auto,h_900,q_auto:good,w_1600/f_webp/v1/energea/br-images/itaguai1.WebP",
  mobile480:
    "https://res.cloudinary.com/energea/image/upload/c_fill,g_auto,h_760,q_auto:eco,w_480/f_webp/v1/energea/br-images/itaguai1.WebP",
  mobile640:
    "https://res.cloudinary.com/energea/image/upload/c_fill,g_auto,h_1013,q_auto:eco,w_640/f_webp/v1/energea/br-images/itaguai1.WebP",
  mobile768:
    "https://res.cloudinary.com/energea/image/upload/c_fill,g_auto,h_1216,q_auto:eco,w_768/f_webp/v1/energea/br-images/itaguai1.WebP",
  mobile900:
    "https://res.cloudinary.com/energea/image/upload/c_fill,g_auto,h_1425,q_auto:eco,w_900/f_webp/v1/energea/br-images/itaguai1.WebP",
};

const HomeHeroSection = ({
  ctaButtonProps = {},
  ctaLabel = "Simular Economia",
  disclaimer = "*As taxas de desconto podem variar de acordo com a região e distribuidora de energia.",
  fullScreen,
  subtitle = "Consumir energia solar é mais barato e agrega valor sustentável à sua marca e ao seu estilo de vida.",
  theme,
  title,
}) => (
  <Grid
    container
    justifyContent="center"
    alignItems="center"
    style={{
      height: `calc(100dvh - (${FEATURE_SECTION_EDGE_INSET} * 2))`,
      minHeight: `calc(100vh - (${FEATURE_SECTION_EDGE_INSET} * 2))`,
      maxHeight: `calc(100dvh - (${FEATURE_SECTION_EDGE_INSET} * 2))`,
      overflow: "hidden",
      borderRadius: `${FEATURE_SECTION_RADIUS}px`,
      width: `calc(100% - (${FEATURE_SECTION_EDGE_INSET} * 2))`,
      margin: FEATURE_SECTION_EDGE_INSET,
      position: "relative",
      background: "#01362E",
    }}
  >
    <picture
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 1,
      }}
    >
      <source
        media="(max-width: 600px)"
        srcSet={`${HOME_HERO_IMAGES.mobile480} 480w, ${HOME_HERO_IMAGES.mobile640} 640w, ${HOME_HERO_IMAGES.mobile768} 768w, ${HOME_HERO_IMAGES.mobile900} 900w`}
        sizes="(max-width: 600px) calc(100vw - 32px), 100vw"
      />
      <source
        media="(min-width: 601px)"
        srcSet={`${HOME_HERO_IMAGES.desktop1024} 1024w, ${HOME_HERO_IMAGES.desktop1280} 1280w, ${HOME_HERO_IMAGES.desktop1600} 1600w`}
        sizes="(min-width: 1600px) 1600px, calc(100vw - 32px)"
      />
      <img
        src={
          fullScreen ? HOME_HERO_IMAGES.mobile640 : HOME_HERO_IMAGES.desktop1600
        }
        alt="Paisagem de usina solar da Energea"
        width="1600"
        height="900"
        loading="eager"
        fetchpriority="high"
        decoding="async"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: "center center",
          display: "block",
        }}
      />
    </picture>
    <div
      aria-hidden
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 2,
        background:
          "linear-gradient(100deg, rgba(14,15,12,0.48) 5%, rgba(14,15,12,0.28) 44%, rgba(14,15,12,0.14) 100%)",
      }}
    />
    <Grid
      item
      style={{
        marginTop: fullScreen ? "5.5rem" : "6rem",
        width: "100%",
        position: "relative",
        zIndex: 3,
      }}
    >
      <Grid container justifyContent="center" style={{ height: "100%" }}>
        <Grid
          item
          container
          {...CONTENT_GRID_PROPS}
          style={{
            ...CONTENT_FRAME_STYLE,
            marginBottom: "2rem",
            ...CONTENT_INNER_STYLE,
          }}
          alignItems="center"
        >
          <Grid
            item
            lg={8}
            md={10}
            xs={12}
            style={{
              padding: fullScreen ? "1.4rem 0.2rem" : "2.25rem 0.2rem",
              maxWidth: fullScreen ? "100%" : "58rem",
            }}
          >
            <Typography
              variant="h1"
              style={{
                color: theme.palette.white.main,
                zIndex: "10000",
                textShadow: "rgba(0,0,0,0.45) 0 0 18px",
              }}
              gutterBottom
            >
              {title}
            </Typography>
            <Typography
              style={{
                color: theme.palette.white.main,
                zIndex: "10000",
                textShadow: "rgba(0,0,0,0.45) 0 0 12px",
              }}
              variant="h5"
              component="p"
              gutterBottom
            >
              {subtitle}
            </Typography>
            <CustomButton
              size="large"
              color="secondary"
              variant="contained"
              style={{
                marginTop: "2rem",
                padding: "0.95rem 2.1rem",
                marginBottom: "2rem",
                fontSize: "1rem",
                boxShadow: "none",
              }}
              endIcon={<ArrowForward />}
              {...ctaButtonProps}
            >
              {ctaLabel}
            </CustomButton>
            <br />
            <Typography
              variant="caption"
              style={{
                color: theme.palette.white.main,
                zIndex: "10000",
                textShadow: "rgba(0,0,0,0.35) 0 0 10px",
                fontSize: "0.75rem",
                opacity: 0.9,
                maxWidth: "85%",
              }}
            >
              {disclaimer}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

export default withStyles(styles, { withTheme: true })(
  withFullScreen(HomeHeroSection, { breakpoint: "sm" })
);
